/**
 * Missing-variant selection + the variant:fetchvariants call (research/05
 * §5.2; REQ-CART-2, SPEC §4.7). `selectMissingVariants` is the verbatim
 * selection from CARTPAGE_adjustLineItems: zero-priced items, else
 * `[first item]`, else `[]`. The endpoint client itself stays in
 * api/fetch-variants.ts (endpoint 8, REQ-API-7) and is re-exported here as
 * the cart-facing surface.
 */
export { CARTPAGE_LoadVariants } from "../api/fetch-variants";

export function selectMissingVariants(allVariantsFromCart: any[]): any[] {
  var missingVariants = allVariantsFromCart.map((a) => a.item).filter((item) => item.price === 0);
  missingVariants = missingVariants.length > 0 ? missingVariants : allVariantsFromCart.length > 0 ? [allVariantsFromCart[0].item] : [];
  return missingVariants;
}
